import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from './AddButton';
import CancelButton from './CancelButton';
import MenuSelector from './MenuSelector';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';
import { getDatatypeMenuOptions } from './utils/utils';

const menuOptions = getDatatypeMenuOptions();

class TypedDialog extends React.Component {

    state = {
        open: false,
        error: false,
        datatype: ""
    };

    handleClickOpen = () => { this.setState({ open: true }) };

    selectType = () => {
        this.setState({ open: false });
        this.props.onSelectType(this.state.datatype === "" ? null : this.state.datatype);
        this.setState({ datatype: "" });
    };

    exitSelectType = () => this.setState({ open: false, datatype: "" });

    handleDatatypeChange = (datatype) => this.setState({ datatype });

    render() {

        const { classes, dataTest } = this.props;
        const { datatype } = this.state;

        return (
            <React.Fragment>
                <AddButton dataTest="add-type" title="Select datatype" onClick={this.handleClickOpen} />
                <Dialog data-test={dataTest} className={classes.dialog}
                    open={this.state.open}
                    onClose={this.exitSelectType} aria-labelledby="createtype-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="createtype-dialog-title">Select Datatype</DialogTitle>
                    <DialogContent style={{ width: '500px' }}>
                        <TitledPanel height="full" title="Datatype">
                            <MenuSelector
                                dataTest="type-selector"
                                handleChange={this.handleDatatypeChange}
                                selected=""
                                hintWord="datatype"
                                options={menuOptions} />
                        </TitledPanel>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitSelectType} />
                        <PrimaryButton disabled={datatype === ""} onClick={this.selectType}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

TypedDialog.propTypes = {
    dataTest: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    onSelectType: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(TypedDialog);
